import { Sentry } from "@/lib/sentry";
import { QueryCache, QueryClient } from "@tanstack/react-query";

function reportReactQueryError(err: Error, meta: Record<string, unknown>) {
  const error =
    err instanceof Error
      ? err
      : new Error(typeof err === "string" ? err : "Unknown error");

  Sentry.withScope((scope) => {
    scope.setTag("source", "react-query");
    scope.setContext("react_query", meta);
    Sentry.captureException(error);
  });
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      reportReactQueryError(error, {
        kind: "query",
        queryKey: query.queryKey,
        meta: query.meta,
      });
    },
  }),

  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
